import { closeCurrentModal } from 'weblite-web-modal-viewer'
import { CallOutlinedIcon } from '$common/icons'
import { PopupMenuItem, PopupMenuList } from '$common/popup-menu'

const PHONE_NUMBERS = [
  '02188914386',
  '02188910756',
  '09923083794',
  '09128014915',
]

interface Props {
  isOpen: boolean
}

export function HonarioonPhoneMenu({ isOpen }: Props) {
  const handleCall = async (phone: string) => {
    await closeCurrentModal()
    window.open(`tel:${phone}`, '_self')
  }

  return (
    <PopupMenuList open={isOpen}>
      {PHONE_NUMBERS.map(phone => (
        <PopupMenuItem
          key={phone}
          text={phone}
          onClick={() => handleCall(phone)}
        >
          <CallOutlinedIcon />
        </PopupMenuItem>
      ))}
    </PopupMenuList>
  )
}
